import cx from "classnames";
import { useTranslation } from "i18n";
import { FEATURE_FLAGS, useLaunchDarklyFlags } from "shared-services";
import { Pill } from "../Pill/Pill";
import { ReactComponent as MediaTimeIcon } from "../../../../src/images/svg/icons/media-time.svg";
import { parseISO, isEqual } from "date-fns";

import "./DateExtendedPill.scss";

const areDatesDiffer = (originalExpiryDate?: string, expiryDate?: string) => {
  if (!originalExpiryDate || !expiryDate) {
    return false;
  }

  return !isEqual(parseISO(originalExpiryDate), parseISO(expiryDate));
};

interface IDateExtendedPillProps {
  currentExpiryDate: string;
  className?: string;
  originalExpiryDate?: string;
  expiryDate?: string;
}

export const DateExtendedPill = ({
  currentExpiryDate,
  className,
  originalExpiryDate,
  expiryDate,
}: IDateExtendedPillProps) => {
  const { t } = useTranslation();
  const isBatchVisible = areDatesDiffer(originalExpiryDate, expiryDate);
  const isExtendDueDateEnabled = useLaunchDarklyFlags(
    FEATURE_FLAGS.ExtendDueDate
  );

  return (
    <div
      className={cx("flex flex-col items-start", {
        "gap-[3px]": isBatchVisible,
      })}
    >
      <span className={className}>{currentExpiryDate}</span>
      {isExtendDueDateEnabled && isBatchVisible && (
        <Pill
          theme="dark"
          size="md"
          icon={<MediaTimeIcon />}
          className="date-extended-pill"
        >
          {t("common:dateExtendedPill.content")}
        </Pill>
      )}
    </div>
  );
};
